export default "__VITE_ASSET__DrlGqjBR__"